import { Injectable } from '@angular/core';
import { Logger } from '@app/@shared/logger.service';
import { Preferences } from '@capacitor/preferences';

const log = new Logger('ip-api-service');

export interface IPData {
  as: string;
  city: string;
  country: string;
  countryCode: string;
  isp: string;
  lat: number;
  lon: number;
  org: string;
  query: string;
  region: string;
  regionName: string;
  status: string;
  timezone: string;
  zip: string;
}

@Injectable({
  providedIn: 'root',
})
export class IpApiService {
  private path = 'ip-data';
  constructor() {}

  async isMx(): Promise<boolean | null> {
    const allowedCountries = ['mx', 'mex'];
    try {
      const data = await this.getIpData(false);
      if (data) {
        return allowedCountries.includes(data.countryCode.toLowerCase());
      }
    } catch (error) {
      log.error('Error al obtener país:', error);
    }
    return null;
  }

  async getIpData(force: boolean): Promise<IPData | null> {
    try {
      if (!force) {
        const prev = await Preferences.get({ key: this.path });
        if (prev.value) {
          return JSON.parse(prev.value) as IPData;
        }
      }

      const res = await fetch('https://pro.ip-api.com/json/?key=iDEXPEa5pKGCKkM');
      const data = await res.json();

      log.info(data);

      if (data) {
        await Preferences.set({
          key: this.path,
          value: JSON.stringify(data),
        });
        return data as IPData;
      }
    } catch (error) {
      log.error(error);
    }

    return null;
  }

  async getIp() {
    try {
      const res = await fetch('https://pro.ip-api.com/json/?key=iDEXPEa5pKGCKkM');
      const data = (await res.json()) as IPData;
      log.info(JSON.stringify(data, null, 2));
      return data;
    } catch (err) {
      log.error(err);
    }

    return null;
  }
}
